(() => {
  const desktopQuery = window.matchMedia('(min-width: 768px)');
  const root = document.documentElement;
  let teardown = null;

  function init() {
    if (teardown) teardown();
    const section = document.querySelector('.section-header');
    const wrapper = section && section.querySelector(':scope > .header-wrapper');
    if (!section || !wrapper) return;

    let frame = 0;
    let geometryFrame = 0;

    const syncGeometry = () => {
      geometryFrame = 0;
      if (!desktopQuery.matches) return;
      const height = Math.ceil(wrapper.getBoundingClientRect().height);
      if (!height) return;
      root.style.setProperty('--ks-pc-fixed-header-height', `${height}px`);
      root.style.setProperty('--ks-pc-anchor-offset', `${height + 18}px`);
    };
    const scheduleGeometry = () => {
      if (!geometryFrame) geometryFrame = window.requestAnimationFrame(syncGeometry);
    };

    const setNaturalHeight = () => {
      const wasCompact = section.classList.contains('ks-desktop-header--fixed');
      section.classList.add('ks-pc-header-measuring');
      section.classList.remove('ks-desktop-header--fixed');
      const height = Math.ceil(wrapper.getBoundingClientRect().height);
      if (height) section.style.setProperty('--ks-pc-original-header-height', `${height}px`);
      if (wasCompact && desktopQuery.matches) section.classList.add('ks-desktop-header--fixed');
      section.classList.remove('ks-pc-header-measuring');
      scheduleGeometry();
    };

    const update = () => {
      frame = 0;
      const compact = section.classList.contains('ks-desktop-header--fixed');
      const next = desktopQuery.matches && window.scrollY > (compact ? 16 : 42);
      if (next !== compact) {
        section.classList.toggle('ks-desktop-header--fixed', next);
        scheduleGeometry();
      }
    };
    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const onResize = () => {
      setNaturalHeight();
      scheduleUpdate();
    };
    const onPanelTransitionEnd = (event) => {
      if (event.target === wrapper && event.propertyName === 'height') scheduleGeometry();
    };

    const observer = typeof ResizeObserver === 'function'
      ? new ResizeObserver(scheduleGeometry)
      : null;
    if (observer) observer.observe(wrapper);

    setNaturalHeight();
    update();
    syncGeometry();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    wrapper.addEventListener('transitionend', onPanelTransitionEnd);
    if (document.readyState !== 'complete') window.addEventListener('load', onResize, { once: true });

    teardown = () => {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', onResize);
      wrapper.removeEventListener('transitionend', onPanelTransitionEnd);
      window.removeEventListener('load', onResize);
      if (frame) window.cancelAnimationFrame(frame);
      if (geometryFrame) window.cancelAnimationFrame(geometryFrame);
      if (observer) observer.disconnect();
      section.classList.remove('ks-desktop-header--fixed');
      section.style.removeProperty('--ks-pc-original-header-height');
      root.style.removeProperty('--ks-pc-fixed-header-height');
      root.style.removeProperty('--ks-pc-anchor-offset');
      teardown = null;
    };
  }

  document.addEventListener('click', (event) => {
    if (!desktopQuery.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href*="#"]');
    if (!link || !link.closest('#MainContent') || link.hasAttribute('download') || link.target === '_blank') return;

    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !target.closest('#MainContent')) return;

    event.preventDefault();
    const offset = parseFloat(getComputedStyle(root).getPropertyValue('--ks-pc-anchor-offset')) || 98;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const destination = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    window.scrollTo({ top: destination, behavior: reduced ? 'auto' : 'smooth' });
    window.history.pushState(null, '', url.hash);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('.section-header') || event.target.querySelector('.section-header')) init();
  });
})();
